import "./App.css";
import Navbar from "./components/pages/Navbar";


function App() {
  return (
    <div>
     <Navbar />
    </div>
  );
}

export default App;
